// The order of a Group's tables is something the admin arranges by hand (drag to reorder), and it is saved as the
// tables' SortOrder. The tables dropdown is a Material multi-select, which hands back its value re-sorted into the
// dropdown's OWN option order every time an item is added or removed - writing that straight into the Group would
// throw the arrangement away. So a change in the selection is merged into the current order instead: tables that
// are still selected keep their place, removed ones drop out, and newly added ones go to the end.
export function mergeTableSelection(current: number[], selected: number[]): number[] {
  const wanted = new Set(selected);
  const kept = current.filter((id) => wanted.has(id));
  const known = new Set(current);
  const added = selected.filter((id) => !known.has(id));
  return [...kept, ...added];
}
